<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>-->
          <!--<div v-if="error" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
          <!--</div>-->
          <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
          <!--</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row class="mb-3">
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMCaseTypeList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p v-if="item.title != null && item.title.length > 0"><b>{{$t('views.excmcasetype.show.title')}}:</b> {{ item.title }}</p>
                  <p v-if="item.subtitle != null && item.subtitle.length > 0"><b>{{$t('views.excmcasetype.show.subtitle')}}:</b> {{ item.subtitle }}</p>
                  <p v-if="item.defaultTask != null"><b>{{$t('views.excmcasetype.show.defaultTask')}}:</b> {{ item.defaultTask.title }}</p>
                  <p v-if="item.accessCaseParams != null && item.accessCaseParams.length > 0"><b>{{$t('views.excmcasetype.show.accessCaseParams')}}:</b> {{ item.accessCaseParams }}</p>
                  <p v-if="item.emailEnable != null && item.emailEnable.length > 0">
                    <b>{{$t('views.excmcasetype.show.emailEnable')}}:</b>
                    <span v-if="item.emailEnable == 0"> {{ $t('buttons.no') }}</span>
                    <span v-if="item.emailEnable == 1"> {{ $t('buttons.yes') }}</span>
                  </p>
                  <p v-if="item.emailTitle != null && item.emailTitle.length > 0"><b>{{$t('views.excmcasetype.show.emailTitle')}}:</b> {{ item.emailTitle }}</p>
                  <p v-if="item.emailContent != null && item.emailContent.length > 0"><b>{{$t('views.excmcasetype.show.emailContent')}}:</b> {{ item.emailContent }}</p>
                  <p v-if="item.caseParams != null && item.caseParams.length > 0"><b>{{$t('views.excmcasetype.show.caseParams')}}:</b> {{ item.caseParams }}</p>
                  <p v-if="item.specialString != null && item.specialString.length > 0"><b>{{$t('views.excmcasetype.show.specialString')}}:</b> {{ item.specialString }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div>
                    <b-button class="btn btn-success" @click="updateItem(item)">{{$t('buttons.edit')}}</b-button>
                    <b-button class="btn btn-warning" @click="archiveItem(item)">{{$t('buttons.archive')}}</b-button>
<!--                    <button class="btn btn-danger" @click="deleteItem(item)">{{$t('buttons.delete')}}</button>-->
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <b-row>
                <b-col sm="6">
                  <h5 class="mt-3 mb-0"><span v-if="item.customFields.length > 0">{{ $t('views.excmcasetype.show.customFields') }}:</span><span v-else>{{ $t('views.excmcasetype.show.noCustomFields') }}</span></h5>
                </b-col>
                <b-col sm="6">
                  <b-btn class="btn btn-success float-right" @click="addNewField(item)">{{ $t('views.excmcasetype.show.addNewCustomField') }}</b-btn>
                </b-col>
              </b-row>
            </div>
            <div class="card-body">
              <b-row v-if="item.customFields && item.customFields.length > 0">
                <b-col>
                  <b-row>
                    <b-col>
                      <b-tabs content-class="mt-3" card no-fade>
                        <b-tab :title="'#' + (index + 1) + ' ' + customField.fieldName" v-for="(customField, index) in item.customFields" v-bind:key="'customField-' + index">
                          <b-row>
                            <b-col>
                              <CustomField :item="customField" :index="index" :items="item.customFields"></CustomField>
                            </b-col>
                          </b-row>
                        </b-tab>
                      </b-tabs>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <CustomFieldAddModal :fieldTypes="fieldTypes"></CustomFieldAddModal>
      <CustomFieldEditModal :fieldTypes="fieldTypes"></CustomFieldEditModal>
      <CustomFieldValueAddModal></CustomFieldValueAddModal>
      <CustomFieldValueEditModal></CustomFieldValueEditModal>
      <CaseTypeEditModal></CaseTypeEditModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CustomField from './components/CustomFieldValue/CustomField'
import CustomFieldAddModal from './components/CustomFieldValue/modal/CustomFieldAddModal'
import CustomFieldEditModal from './components/CustomFieldValue/modal/CustomFieldEditModal'
import CustomFieldValueAddModal from './components/CustomFieldValue/modal/CustomFieldValueAddModal'
import CustomFieldValueEditModal from './components/CustomFieldValue/modal/CustomFieldValueEditModal'
import CaseTypeEditModal from './components/modal/CaseTypeEditModal'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  computed: {
    customFieldObject () {
      return this.$store.state.modals.customField.create.customFieldObject
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deleteError: 'excmcasetype/del/error',
      error: 'excmcasetype/show/error',
      isLoading: 'excmcasetype/show/isLoading',
      item: 'excmcasetype/show/retrieved'
    })
  },

  components: {
    CustomField,
    CustomFieldAddModal,
    CustomFieldEditModal,
    CustomFieldValueAddModal,
    CustomFieldValueEditModal,
    CaseTypeEditModal,
    Loader
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCaseTypeShow')
  },

  data () {
    return {
      fieldTypes: [
        {
          name: this.$t('fieldTypes.input'),
          value: 'input'
        },
        {
          name: this.$t('fieldTypes.select'),
          value: 'select'
        },
        {
          name: this.$t('fieldTypes.datetime'),
          value: 'datetime'
        },
        {
          name: this.$t('fieldTypes.multiSelect'),
          value: 'multiSelect'
        },
        {
          name: this.$t('fieldTypes.inputFormatted'),
          value: 'inputFormatted'
        },
        {
          name: this.$t('fieldTypes.itemsCollection'),
          value: 'itemsCollection'
        },
        {
          name: this.$t('fieldTypes.idUserData'),
          value: 'idUserData'
        }
      ]
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
    this.itemPusher = this.$store.state.Pusher.subscribe('e_x_c_m_case_types-' + this.getIdLink(this.$route.params.id))
    this.itemPusher.bind('e_x_c_m_case_types-' + this.getIdLink(this.$route.params.id), data => {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_case_types-' + this.getIdLink(this.$route.params.id))
  },

  watch: {
    customFieldObject: function (val) {
      if (Object.entries(val).length > 0) {
        this.item.customFields.push(val)
        this.$store.state.modals.customField.create.customFieldObject = {}
      }
    }
  },

  methods: {
    ...mapActions({
      del: 'excmcasetype/del/del',
      reset: 'excmcasetype/show/reset',
      retrieve: 'excmcasetype/show/retrieve'
    }),

    updateItem (item) {
      this.$store.state.modals.caseType.update.show = 1
      this.$store.state.modals.caseType.update.caseTypeObject = item
    },

    addNewField () {
      this.$store.state.modals.customField.create.show = 1
      this.$store.state.modals.customField.create.parent = this.item
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMCaseTypeList' }))
      }
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
